export default __webpack_public_path__ + "static/media/jp-locale.5935487e.svg";